import React, { Fragment } from 'react'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import PropTypes from 'prop-types'

const OneColumnSearchResultsPage = ({
  placeholders: {
    header,
    footer,
    mainContent
  } = {}
}) =>
  <Fragment>
    { header }
    <Wrapper data-max-width data-max-width-padding>
      { mainContent }
    </Wrapper>
    { footer }
  </Fragment>

OneColumnSearchResultsPage.propTypes = {
  placeholders: PropTypes.shape()
}

OneColumnSearchResultsPage.type = 'OneColumnSearchResultsPage'
OneColumnSearchResultsPage.placeholders = ['header', 'mainContent', 'footer']

export default OneColumnSearchResultsPage

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '30px 50px 100px', '30px 0 80px')}
`
